import { render, staticRenderFns } from "./PDPGallery.vue?vue&type=template&id=0fad0615&scoped=true"
import script from "./PDPGallery.vue?vue&type=script&lang=js"
export * from "./PDPGallery.vue?vue&type=script&lang=js"
import style0 from "./PDPGallery.vue?vue&type=style&index=0&id=0fad0615&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad0615",
  null
  
)

export default component.exports